module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "UserInfo",
    attrs: {
      "id": "UserInfo"
    }
  }, [_c('div', {
    staticClass: "user_head_backgound clearfix",
    style: ('background-image:url(' + _vm.imgPath + 'user/mountBg.jpg)'),
    attrs: {
      "id": "user_head"
    }
  }, [_c('div', {
    staticClass: "user_head_img"
  }, [_c('img', {
    attrs: {
      "src": _vm.headImg
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "user_head_name"
  }, [_c('p', [_vm._v(_vm._s(_vm.nickname))]), _vm._v(" "), _c('p', [_vm._v("余额：¥ " + _vm._s(_vm.balance))])])]), _vm._v(" "), _c('div', {
    staticClass: "menuBox"
  }, [_c('div', {
    staticClass: "userMenu"
  }, [_c('a', {
    on: {
      "click": _vm.withdrawals
    }
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'user/recharge.png'
    }
  })]), _vm._v(" "), _c('span', [_vm._v("提现")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/income"
    }
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'user/income.png'
    }
  })]), _vm._v(" "), _c('span', [_vm._v("收入")])]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.toOrders
    }
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'user/orders2.png'
    }
  })]), _vm._v(" "), _c('span', [_vm._v("订单")])]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.toDistribution
    }
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'user/sales2.png'
    }
  })]), _vm._v(" "), _c('span', [_vm._v("分销")])])], 1)]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "is-link": "",
      "to": "/cards"
    }
  }, [_c('img', {
    staticClass: "user_image_type_img",
    attrs: {
      "src": _vm.imgPath + 'user/user_card.png'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "van-cell-text"
  }, [_vm._v("我的卡包")])]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "is-link": "",
      "to": "/historys"
    }
  }, [_c('img', {
    staticClass: "user_image_type_img",
    attrs: {
      "src": _vm.imgPath + 'user/user_eye.png'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "van-cell-text"
  }, [_vm._v("观看历史")])]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "is-link": ""
    },
    on: {
      "click": _vm.toLiveCenter
    }
  }, [_c('img', {
    staticClass: "user_image_type_img",
    attrs: {
      "src": _vm.imgPath + 'user/user_live.png'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "van-cell-text"
  }, [_vm._v("直播中心")])]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "is-link": ""
    },
    on: {
      "click": _vm.toAddr
    }
  }, [_c('img', {
    staticClass: "user_image_type_img",
    attrs: {
      "src": _vm.imgPath + 'user/addrs.png'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "van-cell-text"
  }, [_vm._v("地址管理")])]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "is-link": "",
      "to": "/expend"
    }
  }, [_c('img', {
    staticClass: "user_image_type_img",
    attrs: {
      "src": _vm.imgPath + 'user/consumption2.png'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "van-cell-text"
  }, [_vm._v("消费中心")])]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "is-link": "",
      "to": "/cash/1"
    }
  }, [_c('img', {
    staticClass: "user_image_type_img",
    attrs: {
      "src": _vm.imgPath + 'user/jiangpin2.png'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "van-cell-text"
  }, [_vm._v("奖品中心")])]), _vm._v(" "), _c('van-cell', {
    on: {
      "click": _vm.clearDataAction
    }
  }, [_c('img', {
    staticClass: "user_image_type_img",
    attrs: {
      "src": _vm.imgPath + 'user/huancunqingli.png'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "van-cell-text"
  }, [_vm._v("清空缓存数据")])]), _vm._v(" "), (_vm.ds_id) ? _c('van-cell', {
    on: {
      "click": _vm.goBack
    }
  }, [_c('img', {
    staticClass: "user_image_type_img",
    attrs: {
      "src": _vm.imgPath + 'user/live_back.png'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "van-cell-text"
  }, [_vm._v("返回直播")])]) : _vm._e()], 1), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "right"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "box-center clearfix"
  }, [_c('div', {
    staticClass: "fr"
  }, [_c('van-button', {
    attrs: {
      "type": "default",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.closePp()
      }
    }
  }, [_vm._v("取消")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "valuebox"
  }, [_c('div', [_c('h5', {
    staticClass: "fr"
  }, [_vm._v("您的余额为"), _c('b', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.balance))]), _vm._v(" "), _c('van-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.allPay()
      }
    }
  }, [_vm._v(" 全部提现 ")])], 1), _vm._v(" "), _c('h4', [_vm._v("提现金额")])]), _vm._v(" "), _c('div', {
    staticClass: "input clearfix"
  }, [_c('span', {
    staticClass: "fl"
  }, [_vm._v("￥")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "fl red",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('h6', {
    staticClass: "red"
  }, [_vm._v("特别说明：余额超过2元可提现，将收取20%的手续费，申请成功后在1-2小时内入账微信钱包")])]), _vm._v(" "), _c('div', {
    staticClass: "linebox"
  }, [(_vm.payBut) ? _c('van-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        return _vm.payment()
      }
    }
  }, [_vm._v("立即提现")]) : _c('van-button', {
    attrs: {
      "disabled": "",
      "size": "large"
    }
  }, [_vm._v("立即提现")])], 1), _vm._v(" "), _c('van-number-keyboard', {
    attrs: {
      "show": _vm.show,
      "extra-key": "."
    },
    on: {
      "input": _vm.onInput,
      "delete": _vm.onDelete
    }
  })], 1), _vm._v(" "), _c('van-popup', {
    model: {
      value: (_vm.tixianType),
      callback: function($$v) {
        _vm.tixianType = $$v
      },
      expression: "tixianType"
    }
  }, [_c('div', {
    staticClass: "box-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'user/ok.png'
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "bigsize"
  }, [_vm._v("提现成功")]), _vm._v(" "), _c('p', [_vm._v("已提现"), _c('span', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.realMoney * 100 / 100) + "元")]), _vm._v("至微信钱包")]), _vm._v(" "), _c('van-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        return _vm.ok()
      }
    }
  }, [_vm._v("确定")])], 1)]), _vm._v(" "), _c('van-popup', {
    model: {
      value: (_vm.showPhone),
      callback: function($$v) {
        _vm.showPhone = $$v
      },
      expression: "showPhone"
    }
  }, [_c('div', {
    staticClass: "band"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("提示")]), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('p', [_vm._v("为了保证您的账户安全，"), _c('span', [_vm._v("首次提现")]), _vm._v("需要进行手机绑定。")]), _vm._v(" "), _c('div', {
    staticClass: "phone"
  }, [_c('label', [_vm._v("手机号码：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    attrs: {
      "type": "tel",
      "name": "mobile",
      "maxlength": "11",
      "minlength": "11"
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "code"
  }, [_c('label', [_vm._v("验证码：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "type": "text",
      "name": "code",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.showGet) ? _c('a', {
    staticClass: "getcode",
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v("获取验证码")]) : _c('a', {
    staticClass: "getcode"
  }, [_vm._v(_vm._s(_vm.seconds) + "秒")])])]), _vm._v(" "), _c('div', {
    staticClass: "btns clearfix"
  }, [_c('a', {
    staticClass: "confirm",
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('a', {
    staticClass: "cancel",
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v("取消")])])])]), _vm._v(" "), _c('van-popup', {
    model: {
      value: (_vm.isShowQRimg),
      callback: function($$v) {
        _vm.isShowQRimg = $$v
      },
      expression: "isShowQRimg"
    }
  }, [_c('div', {
    staticClass: "codebox"
  }, [_c('p', [_vm._v(_vm._s(_vm.qrCodeTitle))]), _vm._v(" "), _c('img', {
    staticClass: "stop",
    attrs: {
      "src": _vm.qrCodeUrl
    }
  }), _vm._v(" "), (_vm.qrCodeStr) ? _c('p', [_vm._v(_vm._s(_vm.qrCodeStr))]) : _c('p', [_vm._v("关注公众号后方可提现")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66e361c4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/UserInfo.vue
// module id = 422
// module chunks = 0